import { render, staticRenderFns } from "./b_division_management.vue?vue&type=template&id=4f9f7990"
import script from "./b_division_management.vue?vue&type=script&lang=js"
export * from "./b_division_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports